const params = new URLSearchParams(window.location.search);

const features = {
  pdfviewer: params.has("pdfviewer"),
} as const;

export default features;
